import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup'; // import { Debug } from '../../../Molecules/Forms/Debug';

import { Button, Grid, SubmitButton, Dialog, UserForm } from '../../..';
import { makeStyles } from '@material-ui/core/styles';
var userSchema = Yup.object().shape({
  users: Yup.array().of(Yup.object().shape({
    email: Yup.string().email().min(5, 'Introduce un email').required // these constraints take precedence

  }))
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'wrap'
    },
    mr30: {
      'margin-right': '30px'
    },
    flex: {
      display: 'flex'
    }
  };
});

var DialogUser = function DialogUser(props) {
  var initialValues = {
    users: [{
      email: '',
      central: 'central'
    }]
  };
  var classes = useStyles();
  var title = '';

  if (props.variant === 'edit') {
    title = 'Edit User';
  } else if (props.variant === 'view') {
    title = 'View User';
  } else if (props.variant === 'add') {
    title = 'Add User';
  }

  return [/*#__PURE__*/React.createElement(Dialog, {
    maxWidth: "lg",
    title: title,
    open: props.open,
    onClose: props.onClose,
    mode: props.variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data || initialValues,
    validationSchema: userSchema,
    onSubmit: function onSubmit(values) {
      // setTimeout(() => {
      //   alert(JSON.stringify(values, null, 2));
      // }, 500);
      props.createUserCentral(values);
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        className: classes.flex
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, /*#__PURE__*/React.createElement(UserForm, {
        values: values,
        mode: props.variant,
        central: true
      })), props.variant !== 'view' && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        className: classes.mr30,
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, "Save"))));
    }
  })))];
};

export { DialogUser };